import React, { useState } from "react";
import { Form, PasswordResetProps } from "./types.ts";
import { Modal, notification } from "antd";
import Typography from "../Typography/index.tsx";
import { Column, Row } from "../../themes/globalStyle.ts";
import Button from "../Button/index.tsx";
import ThemeColors from "../../themes/colors.ts";
import { userService } from "../../services/modules/user.ts";
import PasswordInput from "../PasswordInput/index.tsx";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";

const defaultValues: Form = {
  password: "",
  confirm_password: "",
};

const PasswordReset: React.FC<PasswordResetProps> = ({
  isModalOpen,
  setIsModalOpen,
}): JSX.Element => {
  const [form, setForm] = useState<Form>(defaultValues);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleOk = () => {
    setIsLoading(true);

    userService
      .updatePassword(form.password, form.confirm_password)
      .then(() => {
        setIsModalOpen(false);

        notification.success({
          message: "Sucesso!",
          description: "Senha atualizada com sucesso!",
        });
      })
      .finally(() => setIsLoading(false));
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Modal
      destroyOnClose
      title={
        <Typography
          text="Redefinir Senha"
          size="large"
          color="Black500"
          weight={600}
        />
      }
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      width={"30%"}
      centered
      footer={
        <Row style={{ justifyContent: "flex-end" }}>
          <Button
            size="middle"
            borderRadius="0.5rem"
            style={{ width: "fit-content" }}
            backgroundColor={ThemeColors.Black300}
            loading={isLoading}
            onClick={handleCancel}
          >
            <Typography
              text="Cancelar"
              size="medium"
              color="Bg300"
              weight={400}
            />
          </Button>
          <Button
            size="middle"
            borderRadius="0.5rem"
            style={{ width: "fit-content" }}
            backgroundColor={ThemeColors.Black500}
            loading={isLoading}
            onClick={handleOk}
          >
            <Typography
              text="Redefinir"
              size="medium"
              color="Bg300"
              weight={400}
            />
          </Button>
        </Row>
      }
    >
      <Column style={{ gap: "1rem", margin: "2.5rem 0" }}>
        <PasswordInput
          placeholder="Senha"
          iconRender={(visible: boolean) =>
            visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
          }
          visibilityToggle={true}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setForm((prev) => ({ ...prev, password: e.target.value }))
          }
        />
        <PasswordInput
          placeholder="Confirmar senha"
          iconRender={(visible: boolean) =>
            visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
          }
          visibilityToggle={true}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setForm((prev) => ({ ...prev, confirm_password: e.target.value }))
          }
        />
      </Column>
    </Modal>
  );
};

export default PasswordReset;
